

import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { key_assignedTeacherClassesSubjects } from "../utils/constants";
import { getAssignedTeachersClassesSubjects } from "../services/school/teacher/getAssignedTeachersClassesSubjects";

export const useGetAssignedTeachersClassesSubjectsQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [key_assignedTeacherClassesSubjects, JSON.stringify(data)],
    () => getAssignedTeachersClassesSubjects(data),
    options?{...options}:{}
  );